import { DragHandleDots2Icon } from "@radix-ui/react-icons";
import { useState } from "react";
import { useTheme } from "@/components/ui/theme-provider";

interface RankQuestionProps {
  options: string[];
  value: string[];
  onChange: (value: string[]) => void;
}

export const RankQuestion = ({ options, value, onChange }: RankQuestionProps) => {
  const [items, setItems] = useState(value.length ? value : options);
  const { theme } = useTheme();
  const isDarkMode = theme === 'dark';

  const handleDragStart = (e: React.DragEvent, index: number) => {
    e.dataTransfer.setData('text/plain', index.toString());
  };

  const handleDragOver = (e: React.DragEvent) => {
    e.preventDefault();
  };

  const handleDrop = (e: React.DragEvent, dropIndex: number) => {
    e.preventDefault();
    const dragIndex = Number(e.dataTransfer.getData('text/plain'));
    const newItems = [...items];
    const [removed] = newItems.splice(dragIndex, 1);
    newItems.splice(dropIndex, 0, removed);
    setItems(newItems);
    onChange(newItems);
  };

  return (
    <div className="space-y-2">
      {items.map((item, index) => (
        <div
          key={item}
          draggable
          onDragStart={(e) => handleDragStart(e, index)}
          onDragOver={handleDragOver}
          onDrop={(e) => handleDrop(e, index)}
          className={`flex items-center space-x-2 p-2 ${isDarkMode ? 'bg-[#121a2e]' : 'bg-white'} border border-green-500/30 rounded-md cursor-move text-foreground`}
        >
          <DragHandleDots2Icon className="h-5 w-5 text-muted-foreground" />
          <span>{item}</span>
        </div>
      ))}
    </div>
  );
};